<template>
  <AppView class="winners">
    <h1>{{ $t('app.winners') }}</h1>
    <p v-html="$t('app.winnersList')"></p>
  </AppView>
</template>

<script>
import AppView from '@/components/AppView.vue';

export default {
  name: 'Winners',
  components: {
    AppView,
  },
};
</script>

<style lang="scss">
.winners {
  h1 {
    text-align: center;
    font-size: 30px;
  }

  p {
    text-align: center;
    font-size: 24px;
    line-height: 1.25em;

    a {
      color: inherit;
    }

    &:not(:first-child) {
      margin-top: 20px;
    }
  }
}
</style>
